var map = {
	"./bitcoin/index.tsx": [
		66938,
		32
	],
	"./cosmos/index.tsx": [
		93020,
		16
	],
	"./ethereum/index.tsx": [
		35989,
		29
	],
	"./foxPage/index.tsx": [
		77497,
		26
	],
	"./osmosis/index.tsx": [
		34366,
		28
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 27706;
module.exports = webpackAsyncContext;